import { useState } from "react";
import Chart from "react-apexcharts";
import { Card, CardBody } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChartBar } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";

const ApexChart = ({ title = "", data = null }) => {
  const { t } = useTranslation();

  const [chartOptions] = useState({
    chart: {
      id: "basic-bar",
      toolbar: { show: false },
      fontFamily: "Montserrat, sans-serif",
      dropShadow: {
        enabled: true,
        top: 4,
        left: 0,
        blur: 6,
        opacity: 0.08,
      },
    },
    colors: ["#038edc", "#51d28c", "#f1734f"],
    plotOptions: {
      bar: {
        borderRadius: 0,
        columnWidth: "52%",
        dataLabels: { position: "top" },
      },
    },
    dataLabels: { enabled: false },
    grid: {
      borderColor: "#f0f2f5",
      strokeDashArray: 4,
      xaxis: { lines: { show: false } },
    },
    xaxis: {
      categories: data.chartCategories,
      labels: {
        style: { fontSize: "11px", fontWeight: 600, colors: "#9299a8" },
        rotate: -30,
        maxHeight: 60,
      },
      axisBorder: { show: false },
      axisTicks: { show: false },
    },
    yaxis: {
      labels: {
        style: { fontSize: "11px", colors: "#9299a8" },
      },
    },
    legend: {
      position: "top",
      horizontalAlign: "right",
      fontSize: "12px",
      fontWeight: 600,
      markers: { radius: 4, width: 10, height: 10 },
      itemMargin: { horizontal: 10 },
    },
    stroke: { show: true, width: 2, colors: ["transparent"] },
    fill: { opacity: 1 },
    tooltip: {
      theme: "light",
      style: { fontSize: "12px" },
    },
  });

  return (
    data &&
    data.chartSeries.length > 0 &&
    data.chartCategories.length > 0 && (
      <Card style={{ borderRadius: 16, border: "1px solid #eaecf0", boxShadow: "0 2px 8px rgba(0,0,0,0.05)" }}>
        <CardBody>
          <div className="d-flex align-items-center justify-content-between mb-1">
            <h4 className="page-section-header" style={{ marginBottom: 0 }}>
              <span className="page-section-header-icon" style={{ background: "rgba(3,142,220,0.12)" }}>
                <FontAwesomeIcon icon={faChartBar} style={{ color: "#038edc" }} />
              </span>
              {title}
            </h4>
          </div>
          {data.totalStats && (
            <p style={{ fontSize: 12, color: "#9299a8", marginBottom: 16, marginLeft: 44 }}>
              {data.totalStats}
            </p>
          )}
          <Chart
            options={chartOptions}
            series={data.chartSeries}
            type="bar"
            height="380"
          />
        </CardBody>
      </Card>
    )
  );
};

export default ApexChart;
